import { render } from "./Button.vue?vue&type=template&id=b0ba4826&scoped=true"
const script = {}

import "./Button.vue?vue&type=style&index=0&id=b0ba4826&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0ba4826"]])

export default __exports__